const transactionCodesAndTransactionTypes = (state = null, action) => {
  if (action.type === "SET_TRANSACTION_CODES_AND_TRANSACTION_TYPES") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_TRANSACTION_CODES_AND_TRANSACTION_TYPES": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default transactionCodesAndTransactionTypes;
